<script setup lang="ts">
import { BaseButton } from '@magma-app/magma-lapilli';
import Stepper from '@/components/views/ambassador-signup/stepper.vue';
import type { AmbassadorSignupStep } from '@/components/ambassador-signup/config/ambassador-signup-flow-config';

defineProps<{
  step: AmbassadorSignupStep;
  canShowBackButton?: boolean;
}>();
defineEmits<{ back: [] }>();
</script>

<template>
  <div
    class="fixed md:absolute h-20 w-full top-0 left-0 overflow-y-hidden z-20 shrink-0"
  >
    <header class="w-full h-16 bg-white flex items-center px-5">
      <BaseButton
        v-if="canShowBackButton"
        state="scdr"
        class="px-0 w-8"
        icon="arrow-left"
        @click="() => $emit('back')"
      />
      <div v-else class="w-8" />
      <h1 class="flex-1 text-center text-mgm-txt-md font-medium">
        {{ $t('helperOnboarding.mainTitle') }}
      </h1>
      <div class="w-8"></div>
    </header>
    <Stepper :step="step" />
  </div>
</template>
